import {
  SEARCH_INPUT_CHANGED,
  DOCUMENTATION_SEARCH_STARTED,
  DOCUMENTATION_SEARCH_SUCCESS,
  DOCUMENTATION_SEARCH_FAILIED,
  RESET_FOUND_DOCUMENTATION,
} from './types';
import initialState from './initialState';

function searchDocsReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_INPUT_CHANGED:
      return {
        ...state,
        searchText: action.text,
      };
    case DOCUMENTATION_SEARCH_STARTED:
      return {
        ...state,
        loading: true,
      };
    case DOCUMENTATION_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        foundDocumentation: action.foundDocumentation,
      };
    case DOCUMENTATION_SEARCH_FAILIED:
      return {
        ...state,
        loading: false,
      };
    case RESET_FOUND_DOCUMENTATION:
      return {
        ...state,
        foundDocumentation: initialState.foundDocumentation,
        loading: false,
      };
    default:
      return state;
  }
}

export default searchDocsReducer;
